module.exports = __webpack_public_path__ + "static/img/img_4.2f5d5685.jpg";